import { chain, forEach, omit } from 'lodash';
import moment from 'utils/moment';

import API from 'services/TAPS_API';

export default function getSNUS() {
  return API.request({
    method: 'GET',
    url: `/snu/snus`,
    mapper: (data) => mapData(data),
  });
}

function mapData(data) {
  return chain(data)
    .map(function (snu) {
      return {
        snuNumber: snu.snuNumber,
        snuData: {
          snuBody: {
            ...snu,
            snuDate: moment.fromServerDatetime(snu.snuDate),
          },
          snuTypes: mapSnuTypes(snu.sections),
        },
      };
    })
    .keyBy('snuNumber')
    .mapValues('snuData')
    .value();
}

function mapSnuTypes(sections = []) {
  const objects = getObjects(sections);
  const snuTypes = {};

  forEach(objects, (object) => {
    let currentObject = omit(object, 'calculationInfo');
    currentObject.taxAgentKey = `${currentObject.taxAgentInn}_${currentObject.taxAgentKpp}_${currentObject.taxAgentName}`;
    forEach(object.calculationInfo, (calcObject) => {
      const snuCalcObject = Object.assign(
        {},
        calcObject,
        { object: currentObject },
        {
          taxAgentInn: currentObject.taxAgentInn,
          taxAgentKpp: currentObject.taxAgentKpp,
          taxAgentName: currentObject.taxAgentName,
        },
      );

      if (snuTypes[calcObject.sectionType]) {
        snuTypes[calcObject.sectionType].push(snuCalcObject);
      } else {
        snuTypes[calcObject.sectionType] = [snuCalcObject];
      }
    });
  });

  return snuTypes;
}

function getObjects(sections) {
  const objects = [];
  forEach(sections, (section) => {
    forEach(section.taxAuthorityInfo, (taxAuthority) => {
      const objectInfo = taxAuthority.objectInfo || taxAuthority.ndfl2Info || [];
      if (objectInfo.length) {
        const extendedObjects = objectInfo.map((object) =>
          Object.assign({}, object, {
            taxCode: taxAuthority.taxCode,
            propertyType: section.propertyType,
          }),
        );
        objects.push(...extendedObjects);
      }
    });
  });

  return objects;
}
